import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { optimizationApi, type PlatformBenchmark } from '../../api/optimization';

export function BenchmarkDashboardPage() {
  const [benchmarks, setBenchmarks] = useState<PlatformBenchmark[]>([]);
  useEffect(() => { void optimizationApi.benchmarks().then(setBenchmarks); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Benchmark Dashboard</h1>
      <Link to="/optimization" className="mt-2 inline-block text-sm text-violet-700 hover:underline dark:text-violet-400">← Optimization Center</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{benchmarks.map((b) => (
        <div key={b.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
          <p className="font-medium">{b.name}</p>
          <p className="text-sm text-slate-500">{b.module}</p>
          <p className="mt-2 text-xl font-semibold text-green-600">+{b.improvement_pct.toFixed(1)}%</p>
          <p className="text-xs text-slate-500">{b.baseline} → {b.current} {b.unit}</p>
        </div>
      ))}</div>
    </div>
  );
}
